import { IAppState } from '../../../AppModulesWrapper';

export function selectIsAutoProlongAvailable(state: IAppState): boolean {
  const {
    checkoutInfo: { autoProlongInfo },
  } = state.servicePickerWidget;

  return autoProlongInfo.isAvailable;
}
